import {randomNumberRange} from '@coolcolduk/util';
import {ResultMotionItem} from './createResultMotion';
import getWindowDimensions from './util/getWindowDimensions';

const colors = [
  '#FFD700',
  '#FF6B6B',
  '#4ECDC4',
  '#45B7D1',
  '#96CEB4',
  '#FFA500',
  '#FF69B4',
  '#9C27B0',
  '#E91E63',
  '#00BCD4',
];

export interface GenerateConfettiArrayProps {
  count?: number;
  durationSecs?: number;
  delaySecs?: number;
}

export default function generateConfettiArray({
  count = 30,
  durationSecs = 3 + Math.random() * 1,
  delaySecs = Math.random() * 0.1,
}: GenerateConfettiArrayProps = {}): ResultMotionItem[] {
  const {width, height} = getWindowDimensions();

  return [...Array(count)].map((_, i) => {
    // Create confetti from various starting positions
    const isLeftSide = i % 3 === 0;
    const isRightSide = i % 3 === 1;

    let startX;
    let startY;
    if (isLeftSide) {
      startX = randomNumberRange(-0.1, 0.1, true);
      startY = randomNumberRange(-0.2, -0.05, true);
    } else if (isRightSide) {
      startX = randomNumberRange(0.9, 1.1, true);
      startY = randomNumberRange(-0.2, -0.05, true);
    } else {
      // Center confetti
      startX = randomNumberRange(0.4, 0.6, true);
      startY = randomNumberRange(-0.3, -0.1, true);
    }

    // More natural ending positions
    const endX = randomNumberRange(0.1, 0.9, true);
    const endY = randomNumberRange(0.8, 1.2, true);

    // Optimized confetti physics for better performance
    const confettiSize = 8 + Math.random() * 4;
    const rotationSpeed = 180 + Math.random() * 180; // degrees per second
    const totalRotation = rotationSpeed * durationSecs;

    // Simplified wind effect for better performance
    const windEffect = (Math.random() - 0.5) * 0.2;
    const finalX = endX * width + windEffect * width;

    return {
      initial: {
        x: startX * width,
        y: startY * height,
        rotate: 0,
        opacity: 1,
        scale: 0.5,
      },
      animate: {
        x: finalX,
        y: endY * height,
        rotate: totalRotation,
        opacity: [1, 1, 0.8, 0],
        scale: [0.5, 1, 0.8, 0.2],
      },
      transition: {
        duration: durationSecs,
        delay: delaySecs,
        ease: 'easeOut',
        times: [0, 0.3, 0.7, 1],
      },
      style: {
        position: 'absolute',
        width: confettiSize,
        height: confettiSize,
        backgroundColor: colors[i % colors.length],
        borderRadius: Math.random() > 0.5 ? '50%' : '20%',
        willChange: 'transform, opacity',
        transform: 'translateZ(0)', // Force hardware acceleration
      },
    };
  });
}
